import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=20500b86"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
import style0 from "./Main.vue?vue&type=style&index=0&id=20500b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QImg,QTabs,QRouteTab,QBadge,QDrawer,QList,QItem,QItemSection,QIcon,QItemLabel,QPageContainer,QBanner} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QImg,QTabs,QRouteTab,QBadge,QDrawer,QList,QItem,QItemSection,QIcon,QItemLabel,QPageContainer,QBanner})
